import { greetingFor } from '../../lib/greeting';
import { useCurrentUser } from '../../lib/session';
import { useNow } from '../../ui/useNow';
import styles from './EmptyPane.module.css';

function todayLabel(now: number, timeZone: string): string {
  const text = new Intl.DateTimeFormat('es-SV', {
    timeZone, weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).format(new Date(now));
  return text.charAt(0).toLocaleUpperCase('es') + text.slice(1);
}

export function EmptyPane() {
  const user = useCurrentUser();
  // Se recalcula cada minuto: al pasar de franja, el saludo cambia solo.
  const now = useNow(60_000);
  const greeting = greetingFor(user.displayName, user.timezone, new Date(now));

  return (
    <section className={styles.empty} aria-label="Sin conversación abierta">
      <svg className={styles.art} viewBox="0 0 320 120" aria-hidden="true" focusable="false">
        <path className={styles.basting} d="M10 84 C 70 60, 110 104, 170 88 S 260 44, 310 58" />
        <path className={styles.seam} d="M10 96 C 60 80, 90 30, 150 40 S 230 104, 310 70" />
        <circle className={styles.knot} cx="150" cy="40" r="6" />
        <circle className={styles.knotOpen} cx="251.5" cy="80.4" r="5" />
      </svg>
      <p className={styles.today}>{todayLabel(now, user.timezone)}</p>
      <h2 className={styles.title}>{greeting.title}</h2>
      <p className={styles.note}>{greeting.note}</p>
      <p className={styles.instruction}>Elige una conversación para empezar.</p>
      <ul className={styles.legend}>
        <li><span className={styles.ring} data-thread="free" aria-hidden="true" />Aro discontinuo: libre. Tómala para responder.</li>
        <li><span className={styles.ring} data-thread="mine" aria-hidden="true" />Aro firme: la atiendes tú.</li>
        <li><span className={styles.dot} aria-hidden="true" />Punto añil: el cliente espera respuesta.</li>
      </ul>
    </section>
  );
}
